const navigationAction = {
  SET_MENU: "@navigationReducer/SET_MENU",
  TOGGLE_DRAWER: "@navigationReducer/TOGGLE_DRAWER",
};

export default navigationAction;
